import { useState, useEffect } from "react"
import { Select } from "components-design-system"
import { useShallow } from "zustand/react/shallow"

// hoc
import InputWrapper from "../../hoc/InputWrapper/InputWrapper"
import useAuthoringViewStore from "../../../hooks/stores/useAuthoringViewStore"

const areAllObjects = (arr) => {
  return arr.every((item) => typeof item === "object" && item !== null && !Array.isArray(item))
}

const RJDropdown = (props) => {
  const { formView } = useAuthoringViewStore(
    useShallow((state) => ({
      formView: state.formView,
    }))
  )

  let { id, carbonProps, options, value, onChange, originalValue, schema, isTranslation, selectedLanguage, invalid } =
    props
  const [selectedItem, setSelectedItem] = useState(null)
  const [items, setItems] = useState([])

  const handleChange = (e, option) => {
    let foundOption = option
    if (schema?.options && option) {
      foundOption = schema.options.find(
        (item) =>
          item.translations?.[selectedLanguage] === option.text ||
          item.value === option.id ||
          item.label === item?.registries?.[formView.id]
      )
      if (!foundOption) foundOption = option
    }

    onChange(e, foundOption)
  }

  useEffect(() => {
    const getItems = () => {
      if (schema?.options) {
        const items =
          schema?.options
            ?.filter((option) => !(option?.hideInRegistries && option.hideInRegistries.includes(formView.id)))
            ?.map((option) => {
              let ret = {
                id: option.value,
                text: option.label,
              }
              if (option?.registries?.[formView.id]) {
                ret.text = option.registries[formView.id]
              }
              if (option?.translations?.[selectedLanguage]) {
                ret.text = option.translations[selectedLanguage]
              }
              return ret
            }) || []
        return items
      } else if (options?.items || options?.enumOptions) {
        if (options?.items?.length > 0 && areAllObjects(options.items)) {
          return options.items
        } else {
          let items = options.enumOptions
          return items.map((option) => ({ id: option.value, text: option.value }))
        }
      }
      return []
    }

    const getSelectedItem = () => {
      if (isTranslation && originalValue && typeof value !== "object") {
        let foundOption = schema?.options?.find((item) => item.value === originalValue)
        if (foundOption) {
          return { id: originalValue, text: foundOption.translations[selectedLanguage] }
        } else {
          return { id: originalValue, text: originalValue }
        }
      } else if (value && typeof value !== "object") {
        return { id: value, text: value }
      }
      return null
    }

    const items = getItems()
    let selectedItem = getSelectedItem()

    if (selectedItem?.text && schema?.valueMapping?.[formView?.id]?.[selectedItem.id]) {
      if (isTranslation) {
        selectedItem = {
          id: selectedItem.id,
          text: props.value,
        }
      } else {
        selectedItem = {
          id: selectedItem.id,
          text: schema?.valueMapping?.[formView?.id]?.[selectedItem.id],
        }
      }
    }

    setItems(items)
    setSelectedItem(selectedItem)
  }, [options, selectedLanguage, isTranslation, value, originalValue, schema, formView])

  const variant = invalid ? "error" : undefined

  return (
    <div
      id={`${id}-field-wrap`}
      style={{ position: "relative" }}
    >
      <Select
        id={`${id}-field`}
        status={variant}
        disabled={carbonProps?.disabled}
        options={items}
        onChange={handleChange}
        value={selectedItem?.text}
        allowClear={false}
        getPopupContainer={() => document.getElementById(`${id}-field-wrap`)}
      />
    </div>
  )
}

export default InputWrapper(RJDropdown)
